/* rem config */
export default function () {
  /* rem config */
  let deviceWidth = document.documentElement.clientWidth

  // window.remWindowWith = deviceWidth
  document.documentElement.style.fontSize = deviceWidth / 19.2 + 'px'
  document.body.style.fontSize = '0.14rem'
  let needReload = ['/bigScreen', '/home']
  // 屏幕大小变换时
  window.onresize = function () {
    let deviceWidth = document.documentElement.clientWidth

    // window.remWindowWith = deviceWidth
    document.documentElement.style.fontSize = deviceWidth / 19.2 + 'px'
    document.body.style.fontSize = '0.14rem'
    let isReload = needReload.find((item) => `#${item}` === window.location.hash)
    if (isReload) {
      window.location.reload()
    }
  }
}
